import { render } from "./News_1.vue?vue&type=template&id=4c814f52"
import script from "./News_1.vue?vue&type=script&lang=js"
export * from "./News_1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__